import type { FunctionComponent } from 'react';

import type { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';

interface Props {
  customDetail?: ReturnType<typeof useDetail>;
}

export const Disclaimer: FunctionComponent<Props> = () => null;

Disclaimer.displayName = 'VatDisclaimer';
